// extracted by mini-css-extract-plugin
module.exports = {"progressBlock":"Company_progressBlock__bR7eW"};